import { useEffect, useRef, useState } from 'react';

interface UseFullHeightProps {
  bottomPadding?: number;
  shouldListenToResize?: boolean;
}

const useFullHeight = <T extends HTMLElement = HTMLDivElement>({
  bottomPadding = 0,
  shouldListenToResize = true,
}: UseFullHeightProps) => {
  const upperContainerRef = useRef<T>(null);
  const lowerContainerRef = useRef<T>(null);

  const [height, setHeight] = useState<string>('auto');

  const adjustHeights = () => {
    const toUpperContainer = upperContainerRef.current?.getBoundingClientRect().bottom || 0;
    const toLowerContainer = lowerContainerRef.current?.getBoundingClientRect().height || 0;
    const windowHeight = window.innerHeight;
    const calculatedHeight = windowHeight - toUpperContainer - toLowerContainer - bottomPadding;
    setHeight(`${calculatedHeight}px`);
  };

  useEffect(() => {
    adjustHeights();
    if (!shouldListenToResize) return;
    window.addEventListener('resize', adjustHeights);
    return () => {
      window.removeEventListener('resize', adjustHeights);
    };
  }, []);

  return { upperContainerRef, lowerContainerRef, height };
};

export default useFullHeight;
